<template>
    <path fill-rule="evenodd" d="M32 7c0-2.3-.05-2.95-.687-5.569-.088-.362-.37-.643-.732-.737C28.213.113 27.501 0 25.001 0c-4.27 0-7.963 2.469-11.063 6H6.001c-.95 0-1.812.538-2.237 1.382l-3.5 7c-.825 1.663.381 3.62 2.244 3.62H6.65c-.418.937-.806 1.862-1.162 2.756-.15.368-.063.793.225 1.075l4.456 4.456c.281.281.706.369 1.075.225.894-.356 1.819-.744 2.756-1.162v4.144c0 1.856 1.956 3.069 3.619 2.237l7-3.5c.85-.425 1.38-1.288 1.38-2.238v-7.931c3.531-3.1 6-6.795 6-11.064zM3.314 15l3-6h5.293c-1.318 1.894-2.493 3.945-3.537 6H3.314zm5.443 5.639C12.301 11.944 18.313 3 25.007 3c1.412 0 2.168 0 3.674.325.32 1.5.32 2.263.32 3.675 0 6.695-8.944 12.701-17.637 16.245L8.757 20.64zM23 25.689l-6 3v-4.763c2.057-1.037 4.107-2.218 6-3.537v5.3zM23 6c1.657 0 3 1.344 3 3 0 1.657-1.343 3-3 3-1.656 0-3-1.343-3-3 0-1.656 1.344-3 3-3z"/>
</template>

<script>
export default {
    name: 'spaceshipIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 32 32');
    }
};
</script>
